declare namespace $ {

	export class $mol_icon_file extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=file.view.tree.d.ts.map